<template>
<div id="wrapper">
  <CustomHeader :userName="userName"></CustomHeader>
  <div id="hline" class="grad"></div>
  <router-view></router-view>
  <CustomFooter></CustomFooter>
</div>
</template>

<script>
import CustomHeader from './components/common/layout/Header';
import CustomFooter from './components/common/layout/Footer';
import {
  getDataUrl
} from './tools/getUrl.js';
export default {
  name: 'Layout',
  data: function() {
    return {
      userName: ''
    };
  },
  components: {
    CustomHeader,
    CustomFooter
  },
  methods: {
    UpdateWelcomInfo: function() {
      var strEmail = sessionStorage.getItem('email');
      if (strEmail) {
        this.userName = 'Welcome, ' + strEmail;
      } else {
        this.userName = '';
      }
    }
  },
  mounted() {
    this.UpdateWelcomInfo();
  },
  watch: {
    $route() {
      if (this.$route.path.substr(0, 5) === '/Main') {
        this.UpdateWelcomInfo();
      } else {
        this.userName = '';
      }
    }
  }
};
</script>





<style src= "./css/motrex.min.css" ></style>



// WEBPACK FOOTER //
// App.vue?0bfde41a